import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'vehicles': [],
  'loading': false,
};

export const vehicleCombosList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_VEHICLE_COMBOS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_COMBOS]: (state, action) => {
      const data = action.response.data.map((vehicle) =>
        ({'key': vehicle.chassis, 'text': vehicle.chassis, 'value': vehicle.chassis}));
      return (
        {
          ...state,
          'loading': false,
          'vehicles': data,
        }
      );
    },
    [ActionTypes.FETCHED_VEHICLE_COMBOS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicles': [],
    }),
    [ActionTypes.CLEAR_VEHICLES_COMBOS]: (state, action) => ({
      ...state,
      'loading': false,
      'vehicles': [],
    }),
  })(state, action);
};
